// src/data/icons.ts
import {
  HammerIcon,
  TrendingUpIcon,
  BriefcaseIcon,
  DollarSignIcon,
  HomeIcon,
  TargetIcon,
  GlobeIcon,
  LayersIcon,
} from "lucide-react";

export const Icons = {
  HammerIcon,
  TrendingUpIcon,
  BriefcaseIcon,
  DollarSignIcon,
  HomeIcon,
  TargetIcon,
  GlobeIcon,
  LayersIcon,
};
